var map = {
	"./culture-2.png": 1294,
	"./culture.png": 1292,
	"./ecology-2.png": 1263,
	"./ecology-3.png": 1264,
	"./ecology-4.png": 1266,
	"./ecology-completed.png": 2476,
	"./ecology.png": 1262,
	"./entrepreneurship.png": 1267,
	"./improvment-2.png": 1284,
	"./improvment-3.png": 1285,
	"./improvment-4.png": 1287,
	"./improvment.png": 1283,
	"./movement.png": 1289,
	"./park-2.png": 1280,
	"./park-3.png": 1281,
	"./park.png": 1279,
	"./railway.png": 1271,
	"./scooters.png": 1295,
	"./social.png": 1269,
	"./transport-ship.svg": 1291,
	"./transport.png": 1290,
	"./youth-2.png": 1260,
	"./youth.png": 1259,
	"./zoo.png": 1273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2475;